import { ListItem, ListItemButton, ListItemText, Tooltip, Typography } from '@mui/material';

export default function CaseListItem({ caseItem, navToCase }) {
    return (
        <ListItem key={caseItem.id} disablePadding>
            <ListItemButton onClick={() => {
                navToCase(caseItem);
            }}>
                <Tooltip title={caseItem.name + " " + caseItem.description}>
                    <ListItemText primary={
                        <Typography variant="body2">
                            {caseItem.name}
                        </Typography>
                    } secondary={
                        <Typography sx={{textWrap: 'nowrap' }} variant="caption">
                            {caseItem.description}
                        </Typography>
                    } sx={{margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '250px'}}/>
                </Tooltip>
            </ListItemButton>
        </ListItem>
    );
}
